<template>
    <div id="learningability">
        <router-view></router-view>
    </div>
</template>
<script>
    export default {
        components: { },
        props: [],
        data() {
            return {
                isShowjihuoka: false,
                src: "",
                serial_no: '',
                // 记录状态
                zhuangtai: '',
                chushi:false
            }
        },
        computed:{
        },
        methods: {
            // 跳页
            goOnTest() {
                this.$ajax.post(this.G_lcapi + '/test/goon',{
                    test_id: window.sessionStorage.getItem('testId')
                },{
                    headers:{
                        token: window.sessionStorage.getItem('lct_token')
                    }
                })
                    .then(function(res) {
                        var data = res.data;
                        // return;
                        if (data.result.module == 0) {
                            return
                        } else if (data.result.module == 1) {
                            if (data.result.node == 1) {
                               return;
                            } else {
                                this.$router.push('/learningAbility/learningPotential/guide/' + data.result.node);
                            }
                        } else if (data.result.module == 2) {
                            if (data.result.node == 1) {
                                this.$router.push('/learningAbility/Navgation2')
                                return;
                            } else {
                                this.$router.push('/learningAbility/learningMotivation/guide/' + data.result.node);
                            }
                        } else if (data.result.module == 3) {
                            if (data.result.node == 1) {
                                this.$router.push('/learningAbility/Navgation3')
                                return;
                            } else {
                                this.$router.push('/learningAbility/LearningEffectiveness/guide/' + data.result.node);
                            }
                        } else if (data.result.module == 4) {
                            if (data.result.node == 1) {
                                this.$router.push('/learningAbility/Navgation4')
                                return;
                            } else {
                                this.$router.push('/learningAbility/mentalHealth/guide/' + data.result.node);
                            }
                        }
                    }.bind(this))
                    .catch(function(error) {

                    })
            },
            goCreate() {
                var _this = this;
                var serial_no = this.serial_no;
                this.$ajax.post( this.G_lcapi+'/test/create',{
                },{
                    headers:{
                        token:window.sessionStorage.getItem('lct_token')
                    }
                }).then(function(res) {
                        if(res.data.code == 0) {
                            var testId=res.data.result.testId
                            window.sessionStorage.setItem('testId',testId)
                            // code: 1.第一次测试2.继续测试3.测试完成4.绑卡
                            var code = res.data.result.code
                            if(code == 3) {
                                let routeData = this.$router.resolve({ path: '/cepingwancheng' });
                                window.open(routeData.href, '_blank');
                                return;
                            }
                            if(code == 2) {
                                _this.goOnTest();
                                return;
                            }
                        }else if(res.data.code == 1016) {
                            this.url();
                        }
                    }.bind(this))
                    .catch(function(error) {

                    })
            }
        },
        mounted() {
            let token = window.sessionStorage.getItem('ymtxToken')
            window.sessionStorage.setItem('lct_token',token)
            this.goCreate();
        },
    }
</script>
<style lang="less">
    #learningability *{
        box-sizing: border-box;
    }
    #learningability>img{
        display: block;
        margin: 0 auto;
    }
</style>
